var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.566 5H3.65625C2.18864 5 1 6.19602 1 7.65625V23.5938C1 25.0627 2.19738 26.25 3.65625 26.25H28.566C30.0213 26.25 31.2222 25.0677 31.2222 23.5938V7.65625C31.2222 6.19862 30.0383 5 28.566 5ZM28.194 6.77083L17.9894 16.9217C17.4876 17.4234 16.8206 17.6996 16.1111 17.6996C15.4016 17.6996 14.7346 17.4233 14.2312 16.92L4.02824 6.77083H28.194ZM2.77083 23.2333V8.0178L10.4231 15.6297L2.77083 23.2333ZM4.02936 24.4792L11.6786 16.8786L12.9807 18.1738C13.8169 19.01 14.9286 19.4705 16.1111 19.4705C17.2936 19.4705 18.4053 19.01 19.2399 18.1755L20.5436 16.8786L28.1929 24.4792H4.02936ZM29.4514 23.2333L21.7991 15.6297L29.4514 8.0178V23.2333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8b0d714fa19c5249a1e1946863a70253.svg";
export { ForwardRef as ReactComponent };